import { useController } from 'react-hook-form';
import {
  DateTimePicker,
  DateTimePickerProps,
} from 'shared/mui/DatePicker/DateTimePicker/DateTimePicker';

export type DateTimeInputProps = Omit<
  DateTimePickerProps,
  'value' | 'onChange' | 'onBlur' | 'error' | 'helperText' | 'name'
> & {
  source: string;
  label: string;
  onChange?: (value: number | null) => void;
};

export const DateTimeInput: React.FC<DateTimeInputProps> = ({
  source,
  label,
  onChange,
  ...restProps
}) => {
  const {
    field: { onChange: fieldOnChange, onBlur, value },
    fieldState: { error },
  } = useController({ name: source });

  return (
    <DateTimePicker
      {...restProps}
      error={!!error}
      helperText={error?.message}
      label={label}
      onBlur={onBlur}
      onChange={(newValue: number | null) => {
        fieldOnChange(newValue);
        onChange?.(newValue);
      }}
      value={value ?? null}
    />
  );
};
